export const STORAGE_KEYS = {
  THEME: "poocoo-theme",
  DICT: "poocoo-dict",
};

export type Theme = "dark" | "light";

export const UserPreferences = {
  getTheme(): Theme | null {
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.THEME);
      if (stored === "dark" || stored === "light") {
        return stored;
      }
    } catch {
      // localStorage unavailable
    }
    return null;
  },

  setTheme(theme: Theme): void {
    try {
      localStorage.setItem(STORAGE_KEYS.THEME, theme);
    } catch {
      // localStorage unavailable
    }
  },

  getDictionary(): number {
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.DICT);
      if (stored !== null) {
        return parseInt(stored, 10);
      }
    } catch {
      // localStorage unavailable
    }
    return 0;
  },

  setDictionary(dictId: number): void {
    try {
      localStorage.setItem(STORAGE_KEYS.DICT, String(dictId));
      document.cookie = `${STORAGE_KEYS.DICT}=${dictId}; path=/; max-age=31536000; SameSite=Lax`;
    } catch {
      // localStorage unavailable
    }
  },
};
